<template>
    <div :class="[$store.state.layout_style, $store.state.menu_style]">
        <component v-bind:is="layout"></component>
    </div>
    <teleport to="body">
        <div v-if="pdfOpen" class="pdf-overlay" @click.self="pdfOpen = false">
            <button class="pdf-close-outer" @click="closePdf">X</button>
            <div class="pdf-modal">
                <iframe :src="pdfUrl" width="100%" height="100%" style="border: none;" />
            </div>
        </div>
    </teleport>
    <teleport to="#close2">
        <div v-if="pdfOpen" ">
            <button class="pdf-close-outer-left" @click="closePdf">X</button>
        </div>
    </teleport>
</template>
<script setup>
    import {useRoute} from "vue-router";
    import { onMounted, computed, watch } from 'vue';

    import '@/assets/sass/app.scss';

    import { useMeta } from '@/composables/use-meta';
    import { useStore } from 'vuex';

    import { initialized, account } from '@/store/authStore'
    import { useAdminCheck } from '@/composables/regularBackgroundChecks'
    const { listen, destroy } = useAdminCheck()

    const route = useRoute()
    const store = useStore();

    useMeta({ title: 'Client Portal' });

    

    console.log("HAPPEN appvue",route.params.project)
    store.commit('fe_setProject',route.params.project)
    

    const layout = computed(() => {
        return store.getters.layout;
    });

    onMounted(() => {
        console.log("App.vue mounted.")
       
    });

    const pdfOpen = computed(() => store.getters.pdfOpen);
    const pdfUrl = computed(() => store.getters.pdfUrl);
    const closePdf = () => {
        store.commit('closePdfModal');
    };

   watch(account, (newActiveUser) => {
        if (newActiveUser) {
            console.log("🚀 MSAL login finalized. Launching background safety utilities...")
            listen() // Hooks up tab visibility monitoring and handles initial check
        } else {
            destroy() // Wipes listeners clean if user logs out
        }
        }, { immediate: true }
    )

</script>
<script>
    // layouts
    import {useRoute} from "vue-router";
    import appLayout  from './layouts/app-layout.vue';
    import authLayout from './layouts/auth-layout.vue';
    
    console.log("App.vue mounted2.")
    
    export default {
        data() {
            return {
                myproj:{}
            }
        },
        components: {
            app: appLayout,
            auth: authLayout,
        }
    };
</script>
<style scoped>

.pdf-overlay {
    position: fixed !important;
    top: 0; left: 0 !important;
    /* width: 100vw !important;  */
    width: 100% !important; 
    height: 100vh !important;
    min-height: 100% !important;
    background: rgba(0, 0, 0, 0.8) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 9999 !important;
    /* Prevent Safari background pinch/scroll bleed */
    touch-action: none !important; 
    overscroll-behavior: none !important;
}

.pdf-close-outer,.pdf-close-outer-left {
    position: absolute;
    top: 20px;

    border: none;
    font-size: 24px;
    cursor: pointer;
    color: white;
    z-index: 10000;
    background-color: #af3e3e;
}
.pdf-close-outer {
    right:15px;
}
.pdf-close-outer-left {
    left:1px;
}


.pdf-modal, .document-container {
    width: 100%;
    height: 100%;
    background-color: rgba(48, 48, 48, 0.616);
    
}
.pdf-modal {
    background-color: white;
    /* display: flex; */
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* Allow normal scrolling/pinching *only* inside the PDF frame itself */
    touch-action: pan-x pan-y pinch-zoom;
}

iframe {
    background-color: white;
}
</style>